// @ts-check
import { MEASUREMENT_FIELDS } from '../utils/customerMeasurements';

/**
 * Eight body measurements (inches) and a fit note for one piece. Controlled: `measurements` holds the
 * typed text per field, and every change is reported as a patch ({measurements} or {fitNotes}).
 * @param {{
 *   measurements?: Record<string, string>,
 *   fitNotes?: string,
 *   onChange: (patch: {measurements?: Record<string, string>, fitNotes?: string}) => void,
 * }} props
 */
const MeasurementInputs = ({ measurements = {}, fitNotes = '', onChange }) => (
  <div className="space-y-2">
    <div className="grid grid-cols-2 gap-2">
      {MEASUREMENT_FIELDS.map(({ key, label }) => (
        <label key={key} className="text-xs text-muted-foreground">
          {label} (in)
          <input
            type="number"
            inputMode="decimal"
            step="0.25"
            min="0"
            value={measurements[key] ?? ''}
            onChange={(e) => onChange({ measurements: { ...measurements, [key]: e.target.value } })}
            className="w-full mt-1 px-3 py-2 text-base border border-input rounded-lg"
          />
        </label>
      ))}
    </div>
    <textarea
      rows={2}
      placeholder="Fit note (e.g. shorten hem 2 in)"
      value={fitNotes}
      onChange={(e) => onChange({ fitNotes: e.target.value })}
      className="w-full px-3 py-2 text-base border border-input rounded-lg"
    />
  </div>
);

export default MeasurementInputs;
